import { therapyPlanningAction } from 'src/redux/actions/constant';

const { GET_CASE_MIX_GROUP_FAILURE, GET_CASE_MIX_GROUP_SUCCESS, GET_CASE_MIX_GROUP_LOADING } =
  therapyPlanningAction;

const intialState: object = {
  isError: false,
  errorMessage: '',
  response: null,
  loading: false,
};

export const getCaseMixGroupReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case GET_CASE_MIX_GROUP_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isError: false,
        errorMessage: '',
        loading: false,
      };
    }
    case GET_CASE_MIX_GROUP_FAILURE: {
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };
    }
    case GET_CASE_MIX_GROUP_LOADING: {
      return {
        ...intialState,
        loading: true,
      };
    }
    default:
      return state;
  }
};
